export default __webpack_public_path__ + "static/media/quiz.984f3dcf.png";